import camelCaseKeys from 'camelcase-keys';
import { getServiceURL, platform } from '@opengov/api-deprecated';
import {
  IOgqlJobResult,
  IOgqlPollParams,
  IOgqlQueryResult,
  IOgqlViewDetail,
  IOgqlViewListResult,
  IQueryRequestParams
} from '@opengov/ogql-types';

const BASE_PATH = '/api/ogql/v0';

function toCamel(obj: object): object {
  return camelCaseKeys(obj, { deep: true });
}

export async function postQuery(
  params: IQueryRequestParams,
  clientOptions?: RequestInit,
  hostUrl?: string
): Promise<IOgqlJobResult | IOgqlQueryResult> {
  const { viewId, queryString } = params;
  return getServiceURL(hostUrl)
    .content('text/x-sql')
    .options(clientOptions, true)
    .url(`${BASE_PATH}/select?view_id=${viewId}&fast_return=${!!params.fastReturn}`)
    .body(queryString)
    .post()
    .json()
    .then(toCamel) as Promise<IOgqlJobResult | IOgqlQueryResult>;
}

export async function getJob(
  e: IOgqlPollParams,
  clientOptions?: RequestInit,
  hostUrl?: string
): Promise<IOgqlJobResult> {
  return getServiceURL(hostUrl)
    .options(clientOptions, true)
    .url(`${BASE_PATH}/jobs/${e.id}`)
    .get()
    .json()
    .then(toCamel) as Promise<IOgqlJobResult>;
}
export async function getViews(
  { entityId, limit = 1000, offset }: { entityId: number; limit: number; offset?: number },
  clientOptions?: RequestInit,
  hostUrl?: string
): Promise<IOgqlViewListResult> {
  return getServiceURL(hostUrl)
    .options(clientOptions, true)
    .url(`${BASE_PATH}/views`)
    .query({ entity_id: entityId, limit, offset })
    .get()
    .json<IOgqlViewListResult>()
    .then(toCamel) as Promise<IOgqlViewListResult>;
}

export async function getView(
  { viewId }: { viewId: string },
  clientOptions?: RequestInit,
  hostUrl?: string
): Promise<IOgqlViewDetail> {
  return getServiceURL(hostUrl)
    .options(clientOptions, true)
    .url(`${BASE_PATH}/views/${viewId}`)
    .get()
    .json()
    .then(toCamel) as Promise<IOgqlViewDetail>;
}

interface IDatasetColumn {
  id: string;
  special_types: string[];
}

export async function getViewColumns({ viewId }: { viewId: string }, clientOptions?: RequestInit) {
  return platform
    .options(clientOptions, true)
    .url(`/api/grid_data/v3/dataset_columns/`)
    .query({ dataset_id: viewId })
    .get()
    .json()
    .then(toCamel)
    .then((payload: IDatasetColumn[]) => payload);
}
